import gql from "graphql-tag";

export const ProductCardFieldsFragment = gql`
  fragment ProductCardFields on Product {
    _id
    slug
    name
    logo
    description
    isDisruptor
    tags {
      _id
      name
      slug
    }
    inViewerStack
    governmentsUsingCount
    allowRequestTranslation
  }
`;

export default ProductCardFieldsFragment;
